import { v4 as uuidv4 } from "uuid";
export class Field {
  fieldConfig;
  fieldValue;
  config;
  value;
  constructor(fieldConfig, value) {
    this.fieldConfig = fieldConfig;
    this.fieldValue = value;
    this.config = {};
    this.value = null;
  }
}
export class Fields {
}
export function useSlice() {
  const resolveField = (fieldName, fieldConfig, fieldValue) => {
    if (!fieldValue) {
      fieldValue = {
        id: uuidv4(),
        name: fieldName,
        type: fieldConfig.type,
        // If the enabler property is present on the configuration use it's value as the default.
        // If it's not set, set it to true
        enabled: Object.prototype.hasOwnProperty.call(fieldConfig, "enabled") ? fieldConfig.enabled : true,
        config: fieldConfig,
        properties: []
      };
      fieldValue[fieldConfig.type] = fieldConfig.default;
    }
    const fieldClass = new Field(fieldConfig, fieldValue);
    return new Proxy(fieldClass, {
      get(target, property) {
        if (property === "enabled")
          return Object.prototype.hasOwnProperty.call(fieldConfig, "enabled") ? target.fieldValue.enabled : true;
        if (property === "config")
          return target.fieldConfig;
        if (property in target.fieldValue)
          return target.fieldValue[property];
        if (property === target.fieldValue.type || property === "value") {
          if (target.fieldValue.type && typeof target.fieldValue[target.fieldValue.type] !== "undefined") {
            return target.fieldValue[target.fieldValue.type];
          } else {
            return target.fieldConfig.default;
          }
        }
      }
    });
  };
  const resolveFields = (sliceConfig, sliceFields) => {
    if (sliceConfig && sliceConfig.fields) {
      const voixFields = new Fields();
      for (const fieldName of Object.keys(sliceConfig.fields)) {
        const fieldConfig = sliceConfig.fields[fieldName];
        const fieldValue = sliceFields?.find((f) => f.name === fieldName);
        voixFields[fieldName] = resolveField(
          fieldName,
          fieldConfig,
          fieldValue
        );
      }
      const fields = new Proxy(voixFields, {
        get(target, property) {
          if (property in target)
            return target[property];
        }
      });
      return fields;
    }
    return null;
  };
  const getField = (slice, fieldname) => {
    if (slice && slice.fields) {
      const field = slice.fields[fieldname];
      if (field)
        return field;
    }
    return null;
  };
  return {
    resolveFields,
    getField
  };
}
